import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import FormLayout from './FormLayout';
import PlanSelector from '../../components/PlanSelector';
import { FormDataType } from '../../propTypes';
import { UserContext } from '../../contexts/User';

function SelectPlan({
  formData, setFormData, currentStep, setCurrentStep,
}) {
  const { activeWorkspace } = useContext(UserContext);
  return (
    <FormLayout
      heading="Select Your Plan"
      subheading="Choose a plan to unlock powerful features for your workspace"
      currentStep={currentStep.value}
    >
      <PlanSelector
        formData={formData}
        setFormData={setFormData}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        activeWorkspace={activeWorkspace}
        context="signup"
      />
    </FormLayout>
  );
}

SelectPlan.propTypes = {
  formData: FormDataType,
  setFormData: PropTypes.func.isRequired,
  currentStep: PropTypes.shape({
    value: PropTypes.number,
    isReturning: PropTypes.bool,
  }),
  setCurrentStep: PropTypes.func.isRequired,
};

export default SelectPlan;
